import ProjectService from '../../project.service.js';
import { errorMessage, successMessage } from '@/utils/message.js';
import landContractTemplate from '../../contract-comp/land-contract-template/land-contract-template.vue';
import woodsContractTemplate from '../../contract-comp/woods-contract-template/woods-contract-template.vue';
import waterContractTemplate from '../../contract-comp/water-contract-template/water-contract-template.vue';
import sihuangContractTemplate from '../../contract-comp/sihuang-contract-template/sihuang-contract-template.vue';
import houseContractTemplate from '../../contract-comp/house-contract-template/house-contract-template.vue';
import facilityContractTemplate from '../../contract-comp/facility-contract-template/facility-contract-template.vue';
import synthesizeContractTemplate from '@/views/person-center/project/contract-comp/synthesize-contract-template/synthesize-contract-template.vue';

import Service from '@/service/index.js';
const debounce = require('lodash.debounce');
export default {
  components: {
    landContractTemplate,
    woodsContractTemplate,
    waterContractTemplate,
    sihuangContractTemplate,
    houseContractTemplate,
    facilityContractTemplate,
    synthesizeContractTemplate
  },
  data() {
    return {
      projectId: '',
      projectType: '',
      projectSubType: '',
      bidId: '',
      massifType: null,
      projecTypetList: null,
      previewContract: null,
      dialogFormVisible: false,
      ruleForm: {
        refuseReason: ''
      },
      rules: {
        refuseReason: [
          { required: true, message: '请输入100字以内的退回修改原因', trigger: 'change' }
        ]
      }
    };
  },
  created() {
    const query = this.$route.query;
    this.projectId = query.projectId;
    this.bidId = query.bidId;
    this.projectType = query.projectType;
    this.projectSubType = query.projectSubType;
    this.getDictList();
    if (this.projectId) {
      // 获取回显的数据
      this.confirmContractDetails();
    }
  },
  computed: {
  },
  methods: {
    dialogFormclick() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$confirm('确定要退回合同让转让方修改？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit();
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },
    // 拒绝成交提交
    submit() {
      let params =  {
        projectId: this.projectId,
        confirmStatus: false,
        refuseReason: this.ruleForm.refuseReason
      };
      ProjectService.confirmContract(params).then(res => {
        if (res && res.code === '0') {
          successMessage('退回成功');
          this.$router.back();
        }
      });
    },
    confirmContractDetails() {
      ProjectService.displayWoodsContract(this.projectId, this.projectType, '', '2').then(res => {
        if (res && res.code === '0') {
          this.previewContract = res.data;
        }
      });
    },
    // 获取用户类型 字典查询
    getDictList () {
      const obj = {
        MASSIF_TYPE: 'massifType',
        PROJECT_TYPE: 'projecTypetList'
      };
      Object.keys(obj).forEach((key) => {
        Service.getSelectList(key).then(res => {
          if (res && res.code === '0') {
            this[obj[key]] = res.data;
            if(obj[key] === 'projecTypetList') {
              let tempList = res.data.find(item => item.code === '4');
              if(tempList) {
                this[obj[key]] = tempList.list;
              }
            }
          }
        });
      });
    },
    // 返回上一步
    goBack () {
      this.$router.back();
    },
    // 驳回修改
    previewBtn() {
      this.$confirm('确定要退回合同让转让方修改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ProjectService.confirmContract(this.projectId, false).then(res => {
          if (res && res.code === '0') {
            this.$router.back();
          }
        });
      }).catch();
    },
    // 提交
    sureContract: debounce(function(){
      this.$confirm('确定要提交合同？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params =  {
          projectId: this.projectId,
          confirmStatus: true
        };
        ProjectService.confirmContract(params).then(res => {
          if (res && res.code === '0') {
            successMessage('提交成功！');
            this.$router.push('/person-center/project/contracted-project/list');
          } else if (res && res.reason) {
            errorMessage(res && res.reason);
          } else {
            errorMessage('提交合同失败');
          }
        }, (error) => {
          if (error && error.data && error.data.reason) {
            errorMessage(error.data.reason);
          } else {
            errorMessage('提交合同失败');
          }
        });
      }).catch();
    }, 2000, {
      'leading': true,
      'trailing': false
    })
  }
};
